





































import { defineComponent, ref, computed, onMounted, onUnmounted } from '@vue/composition-api';
import { ChevronDownIcon } from 'tdesign-icons-vue';
import { IpcEvents } from '@/ipc-events';
import ipc from '@/renderer/scripts/utils/ipc';
import { getUrlQuery } from '@/renderer/scripts/utils/tools/index';
import JoinMeetingDialog from './components/joinMeeting.vue';
import ScheduleMeetingDialog from './components/scheduleMeeting.vue';
// 引入 compositions
import meetingHandler from './meetingHandler';
export default defineComponent({
  components: {
    ChevronDownIcon,
    JoinMeetingDialog,
    ScheduleMeetingDialog,
  },
  setup(props, context) {
    const { showJoinMeeting, showScheduleMeeting, methods: meetingMethods } = meetingHandler();
    const urlParams = getUrlQuery(window.location.href);
    const clientAuth = (urlParams: any) => {
      if (urlParams.query?.auth_code && urlParams.query?.meetingAction) {
        meetingMethods.authMeeting(urlParams.query.auth_code, urlParams.query.meetingAction);
      }
    };

    // 网页版重定向后直接进行授权操作及会议动作
    clientAuth(urlParams);

    // 客户端这里需要等待scheme的调起命令再进行授权操作及后续会议动作
    const handleClientAuth = (e: any, urlStr: string) => {
      const urlParams = getUrlQuery(urlStr);
      clientAuth(urlParams);
    };
    const methods = {
      onOperateEventProxy(command: string) {
        switch (command) {
          case 'joinMeeting':
            meetingMethods.handleJoinMeeting();
            break;
          case 'quickMeeting':
            meetingMethods.handleQuickMeeting();
            break;
          case 'scheduleMeeting':
            meetingMethods.handleScheduleMeeting();
            break;
          default:
            break;
        }
      },
    };
    onMounted(() => {
      ipc.on(IpcEvents.HANDLE_MEETING_AUTH, handleClientAuth);
    });
    onUnmounted(() => {
      ipc.off(IpcEvents.HANDLE_MEETING_AUTH, handleClientAuth);
    });
    return {
      showScheduleMeeting,
      showJoinMeeting,
      ...methods,
    };
  },
});
